import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import React from 'react';
import { DataTableTW } from 'tailwindComponents/tableTW/DataTableTW';
import { IOrderWorkflow } from 'types/order/workflow/IOrderWorkflow';

export interface IWorkflowsTableProps {
  workflows: IOrderWorkflow[];
}

const columnHelper = createColumnHelper<IOrderWorkflow>();
const columns: ColumnDef<IOrderWorkflow, any>[] = [
  columnHelper.accessor('category', {
    header: 'Category',
  }),
  columnHelper.accessor('state', {
    header: 'Current state',
  }),
];

export const WorkflowsTable: React.FC<IWorkflowsTableProps> = ({ workflows }) => {
  return <DataTableTW columns={columns} data={workflows} isSorted />;
};
